import { Box, type BoxProps } from '@chakra-ui/react';

import type { JSX, RefObject } from 'react';

export interface IFormProps extends BoxProps {
  ref?: RefObject<HTMLFormElement>;
}

export function Form({ ref, ...rest }: IFormProps): JSX.Element {
  return <Box as='form' ref={ref} {...rest} />;
}
